export enum BrowseMenuHoverExperimentVariants {
	Control = 'control',
	Hover = 'hover_on_submenu',
}
